import {
  CreateCallListMutationVariables,
  GetCallContactList,
  useCreateCallListMutation
} from "@bonliva-crm/graphql";
import { HookProps } from "../utils";

export function useCreateCallList(props: HookProps) {
  const [createCallListMutation] = useCreateCallListMutation({});

  const createCallList = (args: CreateCallListMutationVariables) => {
    createCallListMutation({
      variables: {
        type: args.type,
        nodes: args.nodes,
        name: args.name,
        listType: args.listType,
        userIds: args.userIds
      },
      optimisticResponse: (vars) => {
        return {
          submit: {
            __typename: "CallListOpResult",
            callList: {
              _id: "temp",
              __typename: "CallList",
              name: vars.name,
              deleted: false,
              type: vars.type,
              nodes: Array.isArray(vars.nodes) ? vars.nodes : [vars.nodes],
              members: []
            }
          }
        };
      },
      onCompleted: props.onCompleted,
      onError: props.onError,
      refetchQueries: [GetCallContactList.OperationName]
    });
  };

  return { createCallList };
}
